























import Vue from 'vue'
import Component from 'vue-class-component'

import CategoriesTable from '@/components/CategoriesTable.vue'
import PointsTable from '@/components/PointsTable.vue'
import StoreJSON from '@/components/StoreJSON.vue'

@Component({
  components: {
    CategoriesTable,
    PointsTable,
    StoreJSON
  }
})
export default class TablesPanel extends Vue {
}

